import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/${dossierId}/approvemanager`, method: 'PUT', body: null, token: token, lastAccessDate })
}
